<template>
            <!--<div class="md-layout-item md-size-85">-->
        <div>

                <ValidationProvider name="Tenant Details"
                                    ref="tenantDetailsLength"
                                    rules="min_value:2" :custom-messages="{ min_value: 'Please add All tenant details' }">
                    <input type="hidden" v-model="tenantsDetails.length" />
                </ValidationProvider>


                <md-table class="paginated-table tenants-info-table" v-model="tenantsDetails"
                          md-sort="name" md-sort-order="asc">

                    <md-table-row slot="md-table-row" slot-scope="{ item }">

                        <md-table-cell>
                            <div class="actions-container md-layout-item md-alignment-top-left">
                                <md-button class="md-icon-button md-round md-danger" title="Delete"
                                           @click.native="deleteTenant(item)">
                                    <md-icon>delete_outline</md-icon>
                                </md-button>
                            </div>
                        </md-table-cell>

                         <md-table-cell v-if="showChosenSwitch" md-label="Chosen">
                            <div class="actions-container md-layout-item md-alignment-top-left">
                                 <md-switch v-model="item.chosen"></md-switch>
                            </div>
                        </md-table-cell>

                        <md-table-cell md-label="Logo">
                            <draggable :list="item.logos"
                                       :sort="false" class="list-group logos_list" drag-class="being-dragged" ghost-class="ghost" force-fallback="true" fallback-class="being-dragged" group="files">
                                <file-item v-for="file in item.logos"
                                           :key="file.id" :file="file"
                                           class="list-group-item md-elevation-5"></file-item>
                            </draggable>
                        </md-table-cell>

                        <md-table-cell md-label="Name" md-sort-by="name">
                            <ValidationProvider name="Tenant Name"
                                                :ref="'tname'+ item.id"
                                                rules="required|min:3" v-slot="{ passed, failed }">
                                <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                    <label>Tenant Company Name</label>
                                    <md-input v-model="item.name" placeholder="e.g. Tenant Limited" :name="'name'+ item.id" :key="'tnameinp'+ item.id" autocomplete="new-name"></md-input>
                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                </md-field>
                            </ValidationProvider>
                        </md-table-cell>

                        <md-table-cell md-label="Contact Email" md-sort-by="contactEmail">
                            <ValidationProvider name="Tenant Contact Email"
                                                :ref="'tcontactEmail'+ item.id"
                                                rules="required|email" v-slot="{ passed, failed }">
                                <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                    <label>Tenant Contact Email</label>
                                    <md-input v-model="item.contactEmail" placeholder="e.g. contact@tenant.com" autocomplete="new-email"></md-input>
                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                </md-field>
                            </ValidationProvider>
                        </md-table-cell>

                        <md-table-cell md-label="FM Contact Email" md-sort-by="fmContactEmail">
                            <ValidationProvider name="Tenant FM Contact Email"
                                                :ref="'tfmContactEmail'+ item.id"
                                                rules="email" v-slot="{ passed, failed }">
                                <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                    <label>Tenant FM Contact Email</label>
                                    <md-input v-model="item.fmContactEmail" placeholder="If not Tenant Contact Email" autocomplete="new-email"></md-input>
                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                </md-field>
                            </ValidationProvider>
                        </md-table-cell>

                        <md-table-cell md-label="Website">
                            <ValidationProvider name="Tenant Website"
                                                :ref="'twebsite'+ item.id"
                                                :rules="{ min:5, max:2084, regex: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i}" 
                                                v-slot="{ passed, failed }">
                                <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                    <label>Company Website</label>
                                    <md-input v-model="item.website" placeholder="e.g. http://tenantco.com" autocomplete="new-website"></md-input>
                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                </md-field>
                            </ValidationProvider>
                        </md-table-cell>

                    </md-table-row>
                </md-table>
            </div>
</template>

<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate"; //TODO:validate properly https://github.com/logaretm/vee-validate/issues/294    //looks like need the name to be unique so need an index https://jsfiddle.net/hf96yxxy/8/ https://vee-validate.logaretm.com/v2/guide/conditional-and-looping-inputs.html#handling-v-for
    import { required, min, max } from "vee-validate/dist/rules";
    extend("required", required);
    extend("min", min);
    extend("max", max);
    import Swal from "sweetalert2";
    import draggable from 'vuedraggable';
    import FileItem from "./FileItem.vue";
    import Help from "@/ts/Help";

    export default {
        components: {   
            SlideYDownTransition,
            draggable,
            FileItem
        },
        props: {
            tenantsDetails: Array,
            files: null,
            showChosenSwitch: null,
        },
        methods: {
            async validateTable() {
                var respVal = {
                    valid: true,
                    errors:[]
                };
                await Promise.all(Object.values(this.$refs).map(async (v) => {
                    if (!Help.isNullOrUndef(v)) {
                        var valRes = await v.validate();
                        if (!valRes.valid) {
                            respVal.errors.push(valRes.errors); //TODO:upgrade vee val - looks like can then remove the timeout in wiz and maybe this will work too? perhaps ! https://github.com/logaretm/vee-validate/issues/2248
                            respVal.valid = false;
                        }
                    }
                })); 
                return respVal;
            },
            addTenant() {
                this.tenantsDetails.push({ id: this.$uuid.v1(), name:null, logos: [], contactEmail:null,fmContactEmail:null,website:null });
            },
            deleteTenant(item) {
                Swal.fire({
                    title: "Are you sure?",
                    text: `You won't be able to revert, any logos will be returned to the main list`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "Yes, delete it!",
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        this.deleteRow(item);

                        let tenantName = "Unamed Tenant";
                        if (item.name != undefined) { 
                            tenantName = item.name;
                        }

                        Swal.fire({
                            title: "Deleted!",
                            text: `You deleted '${tenantName}'`,
                            type: "success",
                            confirmButtonClass: "md-button md-success btn-fill",
                            buttonsStyling: false
                        });
                    }
                });
            },
            deleteRow(item) {
                let indexToDelete = this.tenantsDetails.indexOf(item);
                if (indexToDelete >= 0) {
                    var self = this;
                    item.logos.forEach(function (l) {
                        self.files.tenantLogos.push(l);
                    });
                    this.tenantsDetails.splice(indexToDelete, 1);
                }
            }
        },
        mounted() {
            if (this.tenantsDetails.length === 0) {
                this.addTenant(); //ensure at least one empty one, to make table render
            }
        }
    }
</script>

<style lang="scss">
    /* No idea why this was missing, stole from inspecting https://vuematerial.io/components/button/
        Without it, md-icon-buttons were not round !!! WTF ???
    */

    .md-icon-button {
        width: 40px;
        min-width: 40px;
        height: 40px;
        margin: 0 6px;
    }

    .md-fab, .md-icon-button {
        border-radius: 50%;
        z-index: 6;
    }

    .paginated-table .md-table-cell .md-table-cell-container,
    .paginated-table .md-table-head {
        padding-right: 10px;
        padding-left: 10px;
    }

    .tenants-info-table td:first-child,
    .tenants-info-table td:nth-child(2) {
        max-width: 50px !important;
        width: 50px !important;
        padding-right: 0px !important;
        padding-left: 0px !important;
    }

        .tenants-info-table td:first-child .md-table-cell-container,
        .tenants-info-table td:nth-child(2) .md-table-cell-container {
            padding-right: 0px;
            padding-left: 0px;
        }
  

    .actions-container {
        text-align: center;
    }

    .tenants-info-table .md-table-row {
        overflow-y: visible !important;
    }

    .tenants-info-table.md-table {
        margin-top: 4rem;
        overflow-y: visible !important;
    }

        .tenants-info-table.md-table .md-table-content {
            overflow-y: visible !important;
        }

    .md-steppers-wrapper {
        overflow-y: visible !important;
    }

    .paginated-table .md-table-head:last-child {
        display: table-cell !important;
    }

    .paginated-table .md-table-cell:last-child .md-table-cell-container,
    .paginated-table .md-table-head:last-child {
        text-align: left !important;
    }

    .paginated-table .md-table-cell:last-child .md-table-cell-container {
        display: block !important;
    }

    .md-icon.md-icon-font.md-theme-default.error {
        color: red;
    }
    .md-icon.md-icon-font.md-theme-default.success {
        color: green;
    }
     
</style>
